var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7481 3.03187L15.4962 4.77997L12 8.27618L13.7238 10L17.22 6.50379L18.9681 8.2519C19.3445 8.62822 20 8.36115 20 7.81487V2.60698C20 2.26707 19.7329 2 19.393 2H14.1851C13.6388 2 13.3718 2.65554 13.7481 3.03187Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLinkIcon);
export default __webpack_public_path__ + "static/media/ArrowLinkIcon.d3bc8cf36862bdefe63d779e5b3e35c1.svg";
export { ForwardRef as ReactComponent };